import {ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {NgClass} from "@angular/common";
import {DomainComponent} from "../domain/domain.component";
import {DomainsSummaryComponent} from "../../controls/domains-summary/domains-summary.component";
import {DomainSearchComponent} from "../../controls/domain-search/domain-search.component";
import {DomainCheckComponent} from "../../controls/domain-check/domain-check.component";

@Component({
    imports: [
        NgClass,
        DomainComponent,
        DomainsSummaryComponent,
        DomainSearchComponent,
        DomainCheckComponent
    ],
    templateUrl: './domains-section.component.html',
    styleUrl: './domains-section.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DomainsSectionComponent {

    currentSection = signal("domain")

    select(section: string) {
        this.currentSection.set(section);
    }
}
